<template>
  <div class="cabinet-setting">
    <div class="main-title">
      <p>通用设置</p>
    </div>
    <div class="main-body">
      <el-row>
        <span class="name-label">服务时间</span>
        <el-time-select
          v-model="deviceConfig.serviceStartTime0"
          :picker-options="{
              start: '00:00',
              step: '00:10',
              end: '23:50'
            }"
          @change="editDevice"
          placeholder="选择服务开始时间">
        </el-time-select>
        --
        <el-time-select
          v-model="deviceConfig.serviceStopTime0"
          :picker-options="{
              start: '00:00',
              step: '00:10',
              end: '23:50'
            }"
          @change="editDevice"
          placeholder="选择服务结束时间">
        </el-time-select>
      </el-row>
      <el-row class="grey">
        <span class="name-label">设备断开通讯</span>
        <el-radio-group v-model="deviceConfig.deviceBreakAlarm" @change="settingChange">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-row>
      <el-row class="text-grey">任意设备通讯断开超过50秒将告警</el-row>
      <el-row class="grey">
        <span class="name-label">空柜校验</span>
        <el-radio-group v-model="deviceConfig.emptyPortQuantityCheckAlarm" @change="settingChange">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-row>
      <el-row class="text-grey">当前空柜数量超过设置的可空空柜数量将告警</el-row>
      <el-row class="grey">
        <span class="name-label">端口校验</span>
        <el-radio-group v-model="deviceConfig.portStatusCheckAlarm" @change="settingChange">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-row>
      <el-row class="text-grey">设备连续15分钟无法收到状态将告警</el-row>
      <el-row class="grey">
        <span class="name-label">柜门校验</span>
        <el-radio-group v-model="deviceConfig.doorStatusCheckAlarm" @change="settingChange">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-row>
      <el-row class="text-grey">设备有一个柜门超过15分钟打开状态将告警</el-row>
      <el-row class="grey">
        <span class="name-label">柜子断电</span>
        <el-radio-group v-model="deviceConfig.devicePowerOffAlarm" @change="settingChange">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-row>
      <el-row class="text-grey">换电柜断电，则告警</el-row>
      <el-row class="grey">
        <span class="name-label">格口断电</span>
        <el-radio-group v-model="deviceConfig.portPowerOffAlarm" @change="settingChange">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-row>
      <el-row class="text-grey">电压或温度异常，自动下断电指令，且超过1分钟没有收到已断电的心跳，则告警</el-row>
      <el-row class="grey">
        <span class="name-label">压差告警</span>
        <el-radio-group v-model="deviceConfig.voltageDifferenceAlarm" @change="settingChange">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-row>
      <el-row class="text-grey">当压差异常时将告警并锁定电池</el-row>
    </div>
    <div class="main-title bbn" style="top:730px">
      <p>设备隔离</p>
    </div>
    <div class="main-body" style="top:775px">
      <table class="table-custom mb10" v-for="(value,key) in adaptConfigMap" :key="key">
        <thead>
        <tr>
          <th class="text-left">换电柜版本：{{ adaptDeviceVersionMap[key] }}</th>
          <th width="10%">操作</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td class="text-left">适用：电池版本<span v-for="item,key in value"
                                             :key="key">{{ deviceVersionMap[item] + ' ' }}</span></td>
          <td>
            <div class="text-btn" @click="editAdaptDevice(key,value)">设置</div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <el-dialog title="选择适用电池版本" width="70%" :visible.sync="dialogVisible">
      <table class="table-custom" style="width: 100%">
        <thead>
        <tr>
          <th class="text-left">
            <el-checkbox v-model="checkAll" @change="checkAllChange">全选</el-checkbox>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td class="text-left">
            <el-checkbox-group v-model="adaptDeviceVersionList" @change="checkedChange">
              <el-checkbox v-for="(v,k) in deviceVersionMap" :key="k" :label="parseInt(k)">电池版本：{{ v }}</el-checkbox>
            </el-checkbox-group>
          </td>
        </tr>
        </tbody>
      </table>
      <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="dialogVisible = false">取消</el-button>
              <el-button type="primary" @click="confirm">确定</el-button>
          </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'cabinetSetting',
  data() {
    return {
      dialogVisible: false,
      deviceConfig: {},
      adaptConfigMap: {},
      adaptDeviceVersionMap: {},
      deviceVersionMap: {},
      checkAll: false,
      deviceVersion: '',
      adaptDeviceVersionList: []
    }
  },
  mounted() {
    this.queryDeviceConfig();
    this.queryDeviceAdaptConfig()
  },
  methods: {
    queryDeviceConfig() {
      let self = this;
      let params = {
        deviceType: 2
      }
      this.$http.post('/managementPlatform/electricity/queryDeviceConfig', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.deviceConfig = res.mdata.deviceConfig;
      }).catch(function (response) {
        console.log(response);
      });
    },
    queryDeviceAdaptConfig() {
      let self = this;
      let params = {
        deviceType: 2,
        adaptDeviceType: 3
      }
      this.$http.post('/managementPlatform/electricity/queryDeviceAdaptConfig', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        let reg = new RegExp(/(\d+):/, 'g')
        let data = res.replace(reg, '"$1":');
        res = JSON.parse(data);
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.adaptConfigMap = res.mdata.adaptConfigMap;
        self.adaptDeviceVersionMap = res.mdata.adaptDeviceVersionMap;
        self.deviceVersionMap = res.mdata.deviceVersionMap;
      }).catch(function (response) {
        console.log(response);
      });
    },
    objToArr(obj) {
      let arr = [];
      for (let key in obj) {
        arr.push({'key': key, 'value': obj[key]});
      }
      return arr;
    },
    settingChange() {
      let self = this;
      this.$confirm('是否确定更改?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.editDevice();
      }).catch(() => {
        self.queryDeviceConfig()
      });
    },
    editDevice() {
      let self = this;
      let params = {
        deviceType: 2,
        serviceStartTime0: this.deviceConfig.serviceStartTime0,
        serviceStopTime0: this.deviceConfig.serviceStopTime0,
        deviceBreakAlarm: this.deviceConfig.deviceBreakAlarm,
        emptyPortQuantityCheckAlarm: this.deviceConfig.emptyPortQuantityCheckAlarm,
        portStatusCheckAlarm: this.deviceConfig.portStatusCheckAlarm,
        doorStatusCheckAlarm: this.deviceConfig.doorStatusCheckAlarm,
        devicePowerOffAlarm: this.deviceConfig.devicePowerOffAlarm,
        portPowerOffAlarm: this.deviceConfig.portPowerOffAlarm,
        voltageDifferenceAlarm: this.deviceConfig.voltageDifferenceAlarm
      }
      this.$http.post('/managementPlatform/electricity/addOrUpdateDeviceConfig', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.$message({
          type: "success",
          message: "编辑成功！",
          center: true
        })
      }).catch(function (response) {
        console.log(response);
      });
    },
    editAdaptDevice(key, value) {
      this.adaptDeviceVersionList = value;
      this.checkedChange();
      this.deviceVersion = key;
      this.dialogVisible = true;
    },
    checkAllChange() {
      let versionList = [];
      for (let key in this.deviceVersionMap) {
        versionList.push(parseInt(key));
      }
      if (this.checkAll) {
        this.adaptDeviceVersionList = versionList;
      } else {
        this.adaptDeviceVersionList = []
      }
    },
    checkedChange() {
      let versionList = [];
      for (let key in this.deviceVersionMap) {
        versionList.push(parseInt(key));
      }
      if (this.adaptDeviceVersionList.length == versionList.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    confirm() {
      let self = this;
      let params = {
        deviceType: 2,
        deviceVersion: this.deviceVersion,
        adaptDeviceType: 3,
        adaptDeviceVersionList: JSON.stringify(this.adaptDeviceVersionList)
      }
      this.$http.post('/managementPlatform/electricity/addOrUpdateDeviceAdaptConfig', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.$message({
          type: "success",
          message: "编辑成功！",
          center: true
        })
      }).catch(function (response) {
        console.log(response);
      });
      self.dialogVisible = false;
    }
  },
}
</script>

<style lang="scss" scoped>
.el-row {
  height: 45px;
  line-height: 45px;
  padding-left: 20px;

  .name-label {
    float: left;
    width: 100px;
  }
}

.table-custom {
  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #BEE6B3;
    cursor: pointer;
  }
}

.grey {
  background-color: #F9F9F9;
}

.text-grey {
  color: #777;
}

.mb10 {
  margin-bottom: 10px;
}

.bbn {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/cabinetSetting.vue